import { useCallback, useState } from "react";
import useJsonApi from "lib/useJsonApi.js";

function useCreateAppointment(sessionUuid) {
  const [request, setRequest] = useState({});

  const response = useJsonApi({
    url: request.url,
    method: "POST",
    body: request.body,
  });

  const createAppointment = useCallback(
    (date, dancers) => {
      setRequest({
        url: `/api/session/${encodeURIComponent(
          sessionUuid
        )}/create-appointment`,
        body: { date, dancers },
      });
    },
    [sessionUuid]
  );

  return [createAppointment, response];
}

export default useCreateAppointment;
